import { render, staticRenderFns } from "./StudentChartFees.vue?vue&type=template&id=e4002790&scoped=true"
import script from "./StudentChartFees.vue?vue&type=script&lang=js"
export * from "./StudentChartFees.vue?vue&type=script&lang=js"
import style0 from "./StudentChartFees.vue?vue&type=style&index=0&id=e4002790&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4002790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4002790')) {
      api.createRecord('e4002790', component.options)
    } else {
      api.reload('e4002790', component.options)
    }
    module.hot.accept("./StudentChartFees.vue?vue&type=template&id=e4002790&scoped=true", function () {
      api.rerender('e4002790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chartStatistical/StudentChartFees.vue"
export default component.exports